export default {
  dashboard: "/manager",
  newHire: (id: string) => `/manager/new-hires/${id}`,
};
